import React, { useState, useEffect } from "react";
import { supabase } from "../lib/supabaseClient";
import Ranking from "./Ranking";

const BetManager = ({
  resultMessage,
  resultWins,
  onBetPlaced,
  bet,
  setBet,
  balance,
  setBalance,
  showModal,
}) => {
  const [betLocked, setBetLocked] = useState(() => {
    const stored = localStorage.getItem("betLocked");
    return stored ? JSON.parse(stored) : false;
  });
  
  const [nickname, setNickname] = useState("");
  const [maxBalance, setMaxBalance] = useState(1000);
  const [nicknameDisabled, setNicknameDisabled] = useState(false);

  // Guardar apuesta y estado bloqueado en localStorage
  useEffect(() => {
    console.log("Guardando bet y betLocked en localStorage:", bet, betLocked);
    localStorage.setItem("bet", bet);
    localStorage.setItem("betLocked", JSON.stringify(betLocked));
  }, [bet, betLocked]);  

  // Recuperar nickname y betLocked desde localStorage
  useEffect(() => {
    const storedNickname = localStorage.getItem("nickname");
    if (storedNickname) {
      setNickname(storedNickname);
      setNicknameDisabled(true);
    }

    const storedBet = localStorage.getItem("bet");
    const storedBetLocked = localStorage.getItem("betLocked");

    console.log("Recuperando del localStorage:");
    console.log("storedBet:", storedBet);
    console.log("storedBetLocked:", storedBetLocked);

    if (storedBet !== null) {
      setBet(Number(storedBet));
    }

    if (storedBetLocked !== null) {
      setBetLocked(JSON.parse(storedBetLocked)); // Asegurarte de que sea un booleano
    }
  }, []);

  const fetchRanking = async () => {
    const { data, error } = await supabase
      .from("ranking")
      .select("*")
      .order("top_score", { ascending: false });

    if (error) {
      console.error("Error al obtener el ranking:", error);
      return [];
    }

    return data;
  };

  useEffect(() => {
    // Insertar jugador si no existe en el ranking
    const checkAndInsert = async () => {
      if (!nickname) return;

      const { data, error } = await supabase
        .from("ranking")
        .select("name")
        .eq("name", nickname)
        .maybeSingle();

      if (!data && !error) {
        await insertPlayer(nickname, balance, balance);
      }
    };

    if (nicknameDisabled) {
      checkAndInsert();
    }
  }, [nicknameDisabled, nickname, balance]);

  const insertPlayer = async (nickname, balance, topScore) => {
    const { data, error } = await supabase
      .from("ranking")
      .insert([{ name: nickname, balance, top_score: topScore }]);

    if (error) {
      console.error("Error al insertar jugador:", error);
    } else {
      console.log("Jugador insertado:", data);
    }
  };

  useEffect(() => {
    if (!resultMessage) return;

    let newBalance = balance;

    if (resultWins === 2) newBalance += Number(bet) * 2;
    else if (resultWins === 1) newBalance += Number(bet);
    else if (resultWins === -1) newBalance -= Number(bet);
    else if (resultWins === -2) newBalance -= Number(bet) * 2;

    setBalance(newBalance);
    localStorage.setItem("balance", newBalance);

    console.log("Nuevo balance guardado:", newBalance);

    if (nickname) {
      const updatePlayerData = async () => {
        try {
          const { data: existingPlayer, error } = await supabase
            .from("ranking")
            .select("top_score")
            .eq("name", nickname)
            .maybeSingle();

          if (error) {
            console.error("Error al obtener datos del jugador:", error);
            return;
          }

          let newTopScore = existingPlayer?.top_score ?? 0;

          if (newBalance > newTopScore) {
            newTopScore = newBalance;
            setMaxBalance(newBalance);
          }

          const { error: updateError } = await supabase
            .from("ranking")
            .upsert({
              name: nickname,
              balance: newBalance,
              top_score: newTopScore,
            });

          if (updateError) {
            console.error("Error al actualizar el jugador:", updateError);
          }
        } catch (err) {
          console.error("Error inesperado:", err);
        }
      };

      updatePlayerData();
    }
  }, [resultMessage]);


  useEffect(() => {
    const checkAndUpdateTopScore = async () => {
      const storedNickname = localStorage.getItem("nickname");
      if (!storedNickname) return;

      try {
        const { data: existingPlayer, error } = await supabase
          .from("ranking")
          .select("top_score")
          .eq("name", storedNickname)
          .maybeSingle();

        if (error) {
          console.error("Error al consultar jugador:", error);
          return;
        }

        const currentTop = existingPlayer?.top_score ?? 0;

        if (balance > currentTop) {
          const { error: updateError } = await supabase
            .from("ranking")
            .update({ top_score: balance })
            .eq("name", storedNickname);

          if (updateError) {
            console.error("Error actualizando top_score:", updateError);
          } else {
            console.log("top_score actualizado exitosamente.");
          }
        }
      } catch (err) {
        console.error("Error inesperado:", err);
      }
    };

    if (showModal) {
      checkAndUpdateTopScore();
    }
  }, [showModal]);
  

  const handlePlaceBet = () => {
    const betAmount = Number(bet);
    if (!nickname) {
      alert("Por favor ingresa un nickname antes de apostar.");
      return;
    }
  
    if (balance === 0) {
      alert("No puedes apostar sin saldo.");
      return;
    }
  
    if (betAmount > 0 && betAmount <= balance) {
      setBetLocked(true); 
      onBetPlaced();      // Llama a la función que maneja la lógica del juego
    } else {
      alert("Apuesta inválida. Debe ser mayor a 0 y menor o igual a tu saldo.");
    }
  };
  

  const handleResetBalance = () => {
    const resetAmount = 1000;
    setBalance(resetAmount);
    localStorage.setItem("balance", resetAmount);
    setBetLocked(false);
    setBet("");
  };

  const handleNicknameChange = (e) => {
    const newNickname = e.target.value;
    setNickname(newNickname);
  };

  const handleSaveNickname = () => {
    if (nickname.trim() !== "") {
      localStorage.setItem("nickname", nickname);
      setNicknameDisabled(true);
    } else {
      alert("Por favor, introduce un nickname válido.");
    }
  };

  return (
    <div>
      <div className="justify-content-center d-flex">
        <div className="justify-content-center d-flex flex-column align-items-center mt-3">
          <input
            type="text"
            value={nickname}
            onChange={handleNicknameChange}
            placeholder="Tu Nickname"
            style={{ width: "150px", marginBottom: "10px" }}
            disabled={nicknameDisabled}
          />

          {!nicknameDisabled && (
            <button
              className="btn btn-dark mb-2"
              onClick={handleSaveNickname}
            >
              Guardar Nickname
            </button>
          )}

          <h3 className="text-white">Saldo: ${balance}</h3>

          {balance <= 0 && (
            <div
              style={{
                color: "red",
                fontWeight: "bold",
                backgroundColor: "black",
                padding: "8px",
                textAlign: "center",
                maxWidth: "300px",
                marginBottom: "10px",
              }}
            >
              Has perdido. No tienes fondos suficientes para apostar.
            </div>
          )}

          <input
            type="number"
            value={bet}
            onChange={(e) => setBet(e.target.value)}
            disabled={betLocked || balance <= 0}
          />
          <button
            className="btn btn-dark m-1"
            onClick={handlePlaceBet}
            disabled={betLocked || balance <= 0}
          >
            Apostar
          </button>

          {balance <= 0 && (
            <button
              className="btn btn-primary mt-2"
              onClick={handleResetBalance}
            >
              Reiniciar Saldo
            </button>
          )}
        </div>
      </div>
      <Ranking fetchRanking={fetchRanking} />
    </div>
  );
};

export default BetManager;
